import * as React from 'react'
import Header from '../../structure/Header/Header'
import {Button, Alert}  from 'react-bootstrap'
import Footer from '../../structure/Footer/Footer'
import ApiCall from '../../../components/ApiCall/ApiCall'
/*
    this class is the page "selectionsite1"
    the user can choose here a website. We will send a certificate to remove all the user data on this website.
*/
interface SuppState {
	site_supp : any
    usernamesite: any
	error:boolean
	message:string
    uuid: any
    name: string
    e: any
}

interface SuppProps {
}

export default class SuppressionDonnee extends React.Component<SuppProps, SuppState> {

    private api = new ApiCall()

    constructor(props: SuppProps){
		super(props)
		this.state = {
            site_supp : [],
            usernamesite:[""],
			error : false,
			message:"",
            uuid:[""],
            name:"",
            e:""
        };
        this.handleChange = this.handleChange.bind(this)
	}

    writeError() {
        let {error, message} = this.state

        if (error === true) {
            return (
                <>
                    <Alert id="error_supp" variant="danger">
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert id="success_supp" variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
    }

    componentDidMount = async () => {
		const request = await this.api.ApiCall("datas", "GET", {}, localStorage.getItem('AccessToken'))
		if(request.status === 200)
		{
			this.setState({
				site_supp : request.data
			})
		}
		else {
			this.setState({
                error: true,
                message: request.data.detail
            })
            window.location.href = "/accueil";
		}
	}

    handleChange(e:any, i:any) {
        const newuuid = [...this.state.uuid];
        newuuid[i] = e.target.value;
        this.setState({uuid: newuuid});
    }

    handleChangeText(e:any, i:any) {
        const newUsernameSite = [...this.state.usernamesite];
        newUsernameSite[i] = e.target.value;
        this.setState({usernamesite: newUsernameSite});
    }

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
                                    <h1 id="data-title-delete" className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                                        Sélection de vos sites
                                    </h1>
								</div>
							</div>
						</div>
					</div>
                    <section id="paiement_section" className="ftco-section">
                        <div className="cart">
                            <div className="table">
                                { this.writeError() }
                                <div className="layout-inline row th">
                                    <div id="formule" className="col col-pro">
                                        Formules
                                    </div>
                                    <div id="web_choice" className="col col-price">
                                        Site choisi
                                    </div>
                                    <div id="username_choice" className="col col-price">
                                        Votre Username sur ces sites
                                    </div>
                                    <div  id="price" className="col">
                                        Prix
                                    </div>
                                </div>
                                <div className="layout-inline row">
                                    <div id="formule" className="col col-total col-numeric">
                                        1 site
                                    </div>
                                    <div id="web_choice" className="col col-total col-numeric">
                                    {this.state.uuid.map((uid:any, i:any)=>{
                                        return(
                                            <>
                                                <div>
                                                    <div id="select_div">
                                                        <select id={i} onChange={(e)=>this.handleChange(e, i)}>
                                                            <option value="select">Choisissez votre site web</option>
                                                            {this.state.site_supp.map(function(item : any){
                                                                return(
                                                                    <>
                                                                        <option value={item.uuid}>{item.name}</option>
                                                                    </>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <br/>
                                                    <br/>
                                                    <br/>
                                                </div>
                                            </>
                                        )
                                    })}
                                    </div>
                                    <div id="username_choice" className="col col-total col-numeric">
                                    {this.state.uuid.map((uid:any, i:any)=>{
                                        return(
                                            <>
                                                <div>
                                                    <div id="username_div">
                                                        <input id="username" placeholder="Username" onChange={(e)=>this.handleChangeText(e, i)}></input>
                                                    </div>
                                                    <br/>
                                                    <br/>
                                                    <br/>
                                                </div>
                                            </>
                                        )
                                    })}
                                    </div>
                                    <div id="price" className="col col-total col-numeric">
                                        <p>
                                            Free
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                            </div>
                        </div>
                        <Button id="button_paiement" variant="success" target="__blank" onClick={this.SbmitPayement}>
                            Valider
                        </Button>
                        {/* <Button href="https://www.paypal.com/fr/home" target="__blank" variant="success">Payer</Button> */}
                    </section>
				<Footer/>
				</div>
			</>
		);
	}

    SbmitPayement = async () => {
        var dict = this.state.uuid.map((uid:string, i:any) => {
            return({
                uuid: uid,
                username: this.state.usernamesite[i]
            })
        });

        const request = await this.api.ApiCall("datas", "POST",
        {
            websites : dict
        }, localStorage.getItem('AccessToken'))
        if (request.status === 202) {
            this.setState({
                error: false,
                message: "Votre demande de suppression de données a été prise en compte par nos services. Elle sera traitée dans les plus bref délais. Merci de votre confiance."
            })
        } 

        if (request.status === 400) {
            this.setState({
                error: true,
                message: "Veuillez choisir un site internet"
            })
        }

        if (request.status === 404) {
            this.setState({
                error: true,
                message: "Le site que vous recherchez n'existe pas"
            })
        }
    }
}